import {ReportApi, ReportByCompanyDto, ApiReportBycompanyStartEndGetArgs, Configuration} from "../generated-api";
import { getCustomHeaders } from "./user";

const {REACT_APP_API_DOMAIN} = process.env;
const reportAPI = new ReportApi(new Configuration({basePath: REACT_APP_API_DOMAIN, getHeaders: getCustomHeaders}));

export const getReportByCompany = (start?: string, end?: string): Promise<ReportByCompanyDto>  => reportAPI.apiReportBycompanyStartEndGet(new ApiReportBycompanyStartEndGetArgs({start, end}));